
























































































    import { Vue, Component, Prop } from "../../Infrastructure/CorBase/CoreBase";  

				@Component
        export default class BaseTLModalDialog extends Vue {          
					@Prop({ type: String, required: true, default: "" }) id!: "";
					@Prop({ type: String, required: false, default: "" }) idHelp?: string; //pomocnéId
					@Prop({ type: String, required: false, default: "" }) idHelp2?: string; //pomocnéId 2
					@Prop({ type: String, required: false, default: "" }) idHelp3?: string; //pomocnéId 3
					@Prop({ type: Number, required: false, default: 0 }) idHelp4?: number; //pomocnéId 4 number
					@Prop({ type: Boolean, required: false, default: false }) idHelp5?: boolean; //pomocnéId 4 number
					@Prop({ type: String, required: true, default: null }) title?: string;
					@Prop({ type: String, required: false, default: '' }) content?: string;
					@Prop({ type: Boolean, required: false, default: false }) isAllCorrect?: boolean;
					@Prop({ type: Boolean, required: false, default: true }) okOnly?: boolean; // když je false tak je Ano a Ne
					@Prop({ type: String, required: false, default: 'Ok' }) okButtonTitle?: string;
					@Prop({ type: String, required: false, default: 'Ne' }) cancelButtonTitle?: string;

					@Prop({ type: Boolean, required: false, default: false }) isListModal?: boolean; //jedna se o seznam - jeste nefunguje
					@Prop({ type: Boolean, required: false, default: false }) isDetailForm?: boolean; //jedna detailový formulář, např. nepřítomnost, pracovní výkon

					@Prop({ type: Array, required: false }) useOwnEnumsSendArray1!: any[]; //tady vlastní kolekce pro formuláře (např. zaměstnanci, výkony)
					@Prop({ type: Array, required: false }) useOwnEnumsSendArray2!: any[]; //tady vlastní kolekce pro formuláře (např. zaměstnanci, výkony)

					//tabulka
					@Prop({ type: Boolean, required: false, default: false }) isUseTable?: boolean; //jedna se o vyberový seznam -
					@Prop({ type: String, required: false, default: 'Persons' }) useTableType?: string; //určíme co chceme zobrazit 1)employee - zamestnanci 2) persons - osoby
				                                                                                                          
					@Prop({ required: false }) itemsData: any; //zakladni datova napln
					@Prop({ required: false }) fields: any;  //jmena sloupců
					@Prop({ type: String, required: false, default: "" }) defaultSortBy?: string; //sortBy - při prvním zobrazení

					@Prop({ type: Boolean, required: false, default: true}) hideHeaderClose?: boolean; //schování zavíracího křízku nahoře

					@Prop({ type: String, required: false, default: "main" }) variant?: string;
					@Prop({ type: String, required: false, default: "normal" }) size?: string; //velikost - typy se urcuji v css
					@Prop({ type: Boolean, required: false, default: false }) styleMain?: boolean;
					@Prop({ type: String, required: false, default: "" }) returnRoute?: string; //kam presmerovat po Ok
					@Prop({ type: String, required: false, default: "0" }) returnId?: string; //kam presmerovat po Ok - id navratu
					@Prop({ required: false }) returnLocation: any; //kam presmerovat po Ok - id navratu
					@Prop({ type: Boolean, required: false, default: false }) isCentered?: boolean; //jedna se o vyberový seznam -

					onClickOk(userId: any) {					
						this.$bvModal.hide(this.id);

						if (this.isDetailForm || this.okOnly == false) {
							this.$emit('changes', userId);
						}

						if (this.isAllCorrect) {
							if (this.returnId != "0") {
								userId = this.returnId;
							}

							if (this.returnLocation) {
								this.$router.push(this.returnLocation);
							} else {
								if (this.returnRoute != '') {
									this.$router.push({ name: this.returnRoute, params: { id: userId } });
								}
							}
						}
					};		

					//při vyberu ze seznamu
					selectItem(userId: any) {	
						this.$emit('selectItem', userId);
						this.onClickOk(userId);
					};

					hideModal(data: any) {
						this.onClickOk(data);
					}	

					//načtení stylu
					get inputClass() {
						return {
							".modal .modal-big": this.isUseTable

						};
					}
	}


